import React from "react";
import DataTable from "./components/DataTable";
import ChatBox from "./components/ChatBox";

const App = () => {
    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <h1 className="text-3xl font-bold text-center mb-6">
                Sistema de Interacción con IA
            </h1>
            <div className="p-4 mx-auto flex flex-col md:flex-row gap-2">
                {/* Data Table */}
                <div className="w-2/4">
                    <DataTable />
                </div>
                {/* ChatBox */}
                <div className="w-2/4">
                    <ChatBox />
                </div>
            </div>
        </div>
    );
};

export default App;
